export default __webpack_public_path__ + "static/media/header-bottom-industry.2363517d.png";